import { AppCustomMenu } from '@lmt/unicorn-shared/app/components/common/ui-kit/menu/AppCustomMenu';
import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import styles from './OptionList.module.scss';

interface OptionListProps<D> {
  textClassName?: string;
  optionContainerClassName?: string;
  isRecentlySearched: boolean;
  options: D[];
  onOptionClick: (option: D) => void;
  extractOptionKey: (option: D) => string | number;
  renderOption: (option: D) => JSX.Element;
  renderAnyAvailableOption?: () => JSX.Element;
  onAnyAvailableOptionClick?: () => void;
  targetId?: Element | undefined | null;
  renderHeader?: () => JSX.Element;
  renderBottom?: () => JSX.Element;
  selectedOptionKey?: string | number;
  onClose?: () => void;
}

export function OptionList<D>(props: OptionListProps<D>) {
  const {
    textClassName,
    optionContainerClassName,
    isRecentlySearched,
    onOptionClick,
    options,
    extractOptionKey,
    renderOption,
    renderAnyAvailableOption,
    targetId,
    renderHeader,
    renderBottom,
    selectedOptionKey,
    onClose,
  } = props;

  const i18n = useTranslation();
  return (
    <AppCustomMenu
      anchorEl={targetId}
      open={!!targetId}
      onClose={onClose}
      data-test-id="drop-down-option-list"
    >
      <div
        className={styles.optionListContainer}
        data-test-id="option-list-container"
      >
        {renderHeader && (
          <div className={optionContainerClassName}>{renderHeader()}</div>
        )}
        {isRecentlySearched && (
          <div className={styles.recentlySearchedContainer}>
            <span className={clsx(styles.recentSearchText, textClassName)}>
              {i18n.t('uikit.search.recent_searches')}
            </span>
          </div>
        )}
        {renderAnyAvailableOption && (
          <div
            className={clsx(styles.optionContainer, optionContainerClassName)}
            onClick={() => props.onAnyAvailableOptionClick?.()}
            data-test-id="resource-item"
          >
            {renderAnyAvailableOption()}
          </div>
        )}
        {options.map((option) => (
          <div
            key={extractOptionKey(option)}
            className={clsx(
              styles.optionContainer,
              optionContainerClassName,
              selectedOptionKey && extractOptionKey(option) == selectedOptionKey
                ? styles.selectedOption
                : undefined,
            )}
            onMouseDown={(event) => event.preventDefault()} // to prevent input's onBlur() being fired before item's onClick()
            onClick={() => onOptionClick(option)}
          >
            {renderOption(option)}
          </div>
        ))}
        {renderBottom && (
          <div
            className={clsx(styles.bottomContainer, optionContainerClassName)}
          >
            {renderBottom()}
          </div>
        )}
      </div>
    </AppCustomMenu>
  );
}
